export default __webpack_public_path__ + "static/media/Manit05.a5a8f05f.png";